export default {
  init() {},
  finalize() {
    let validator = $("#candidacies-form").validate({
      onfocusout: false,
      onkeyup: false,
      onclick: false,
      errorElement: "div",
      errorClass: "invalid-feedback",
      errorPlacement: function (error, element) {
        error.appendTo(element.closest(".form-group"));
      },
      highlight: function (element) {
        $(element).closest().addClass("invalid");
      },
      unhighlight: function (element) {
        $(element).closest().removeClass("invalid");
      },
      submitHandler: function (form) {
        let $form = $("#candidacies-form");
        let $formData = new FormData($form.get(0));

        $.ajax({
          type: "POST",
          url: $form.attr("action"),
          data: $formData,
          dataType: "JSON",
          processData: false,
          contentType: false,
          beforeSend: function () {
            $("#submit-candidacies-form").addClass("processing");
            $("#submit-candidacies-form").prop("disabled", true);
            $(".alert-contact").removeClass("d-flex");
          },
          complete: function (data) {
            setTimeout(function () {
              let timeOut = 0;
              if (
                (data.responseJSON && data.responseJSON.error === true) ||
                data.status !== 200
              ) {
                $("#submit-candidacies-form").addClass("fail");
                $(".alert-contact")
                  .removeClass("alert-success")
                  .addClass("alert-danger d-flex")
                  .empty()
                  .append(data.responseJSON.error_message);
              } else {
                _paq.push([
                  "trackEvent",
                  "Jobs",
                  "Soumission réussie du formulaire de candidature",
                ]);
                $form.find(":input:not([type=hidden]), select").val("");
                $("#submit-candidacies-form").addClass("success");
                $(".alert-contact")
                  .removeClass("alert-danger")
                  .addClass("alert-success d-flex")
                  .empty()
                  .append(
                    "Nous avons bien reçu votre candidature, nous tâcherons d'y répondre dans les plus brefs délais"
                  );
                timeOut = 3000;
                setTimeout(function () {
                  $(".alert-contact")
                    .removeClass("alert-success alert-danger d-flex")
                    .addClass("d-none");
                  $("#modalCandidacy").modal("hide");
                }, timeOut);
              }
              setTimeout(function () {
                $("#submit-candidacies-form").removeClass(
                  "processing success fail"
                );
                $("#submit-candidacies-form").prop("disabled", false);
              }, timeOut);
            }, 500);
          },
        });
      },
    });

    $('[aria-labelledby="modalJob"]').on("hidden.bs.modal", function () {
      validator.resetForm();
    });
  },
};
